export default __webpack_public_path__ + "static/mohamed-3840f25d34c9c032b7dc8585a5d6b8bf.png";